import { computed, reactive, type ComputedRef } from 'vue';

interface MapPickerState {
  isPickingOnMap: boolean;
}

// The link dialog itself is TinyMCE's own window; only the map overlay is a Vue
// component, and it is shared by every editor on the page — hence module scope.
const state = reactive<MapPickerState>({ isPickingOnMap: false });

// The callback is a function and must not become reactive, so it lives beside
// the state rather than inside it.
let onChosen: ((href: string) => void) | null = null;

export interface UseEditorLinkReturn {
  state: MapPickerState;
  isPickingOnMap: ComputedRef<boolean>;
  openMapPicker: (callback: (href: string) => void) => void;
  resolveMapPick: (href: string) => void;
  closeMapPicker: () => void;
}

export function useEditorLink(): UseEditorLinkReturn {
  function openMapPicker(callback: (href: string) => void): void {
    onChosen = callback;
    state.isPickingOnMap = true;
  }

  function resolveMapPick(href: string): void {
    const callback = onChosen;
    closeMapPicker();
    callback?.(href);
  }

  function closeMapPicker(): void {
    state.isPickingOnMap = false;
    onChosen = null;
  }

  return {
    state,
    isPickingOnMap: computed<boolean>(() => state.isPickingOnMap),
    openMapPicker,
    resolveMapPick,
    closeMapPicker,
  };
}
